"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var moment_1 = __importDefault(require("moment"));
var lodash_1 = require("lodash");
var review_star_1 = __importDefault(require("~/components/common/review_star"));
var highlighter_1 = __importDefault(require("~/util/highlighter"));
var MAX_CONTENT_LENGTH = 400;
var formatCreatedAt = function (createdAt) {
    moment_1.default.locale('ja');
    return (0, moment_1.default)(createdAt).format('LLL');
};
var formatContent = function (content, searchWords) {
    var highlighter = new highlighter_1.default();
    var truncated = (0, lodash_1.truncate)(content, { length: MAX_CONTENT_LENGTH });
    return highlighter.highlight((0, lodash_1.escape)(truncated), searchWords);
};
var Row = function (_a) {
    var review = _a.review, searchWords = _a.searchWords, isSmartPhone = _a.isSmartPhone;
    return (react_1.default.createElement("div", { className: "coSearchReviewSearchResultRow-ListCell" },
        !isSmartPhone && (react_1.default.createElement("a", { href: review.enterprise.url, className: "coSearchReviewSearchResultRow-StoreInfo" },
            react_1.default.createElement("div", { className: "coSearchReviewSearchResultRow-StoreInfo_Name" }, review.enterprise.name),
            react_1.default.createElement("img", { src: review.enterprise.image_url, alt: review.enterprise.name, className: "coSearchReviewSearchResultRow-StoreInfo_Image lazyload" }))),
        react_1.default.createElement("div", { className: "coSearchReviewSearchResultRow-ReviewContent" },
            react_1.default.createElement("div", { className: "coSearchReviewSearchResultRow-ReviewContent_Header" },
                react_1.default.createElement("div", { className: "coSearchReviewSearchResultRow-ReviewContent_RatingContainer" },
                    react_1.default.createElement(review_star_1.default, { rate: review.rating, showRateNumber: false }),
                    react_1.default.createElement("div", { className: "coSearchReviewSearchResultRow-ReviewContent_RatingNumber" }, review.rating)),
                !isSmartPhone && (react_1.default.createElement("div", { className: "coSearchReviewSearchResultRow-ReviewContent_ReviewerWrapper" },
                    react_1.default.createElement("div", { className: "coSearchReviewSearchResultRow-ReviewContent_ReviewerName" },
                        "\u6295\u7A3F\u8005: ",
                        review.reviewer_name),
                    review.map && (react_1.default.createElement("div", { className: "coSearchReviewSearchResultRow-ReviewContent_MapName" },
                        "(",
                        review.map.name,
                        ")")))),
                react_1.default.createElement("div", { className: "coSearchReviewSearchResultRow-ReviewContent_CreatedAt" }, formatCreatedAt(review.created_at))),
            isSmartPhone && (react_1.default.createElement("div", { className: "coSearchReviewSearchResultRow-ReviewContent_ReviewerWrapper" },
                react_1.default.createElement("div", { className: "coSearchReviewSearchResultRow-ReviewContent_ReviewerName" },
                    "\u6295\u7A3F\u8005: ",
                    review.reviewer_name),
                review.map && (react_1.default.createElement("div", { className: "coSearchReviewSearchResultRow-ReviewContent_MapName" },
                    "(",
                    review.map.name,
                    ")")))),
            react_1.default.createElement("div", { className: "coSearchReviewSearchResultRow-ReviewContent_Body", dangerouslySetInnerHTML: { __html: formatContent(review.content, searchWords) } }),
            react_1.default.createElement("div", { className: "coSearchReviewSearchResultRow-ReviewContent_Footer" },
                react_1.default.createElement("a", { href: review.enterprise.url, className: "right_link" },
                    "\u300C",
                    review.enterprise.name,
                    "\u300D\u306E\u30AF\u30C1\u30B3\u30DF\u3092\u898B\u308B")))));
};
exports.default = Row;
